import React from "react";
import { InsPortfolioCreationRulesBasedGrid } from "./insPortfolioCreationRulesBasedGrid";
import { InsPortfolioCreationRulesBasedTabBase } from "./insPortfolioCreationRulesBasedTabBase";
import { useGetDatapointsPortfolioCreationFilters } from "components/workspaces/hooks/use-get-filter-values";
export const InsPortfolioCreationRulesBasedTab = () => React.createElement(InsPortfolioCreationRulesBasedTabBase, { useFiltersHook: useGetDatapointsPortfolioCreationFilters, GridComponent: InsPortfolioCreationRulesBasedGrid });
